// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"471":"7c26743e","713":"2d25cb37","930":"e6c6b601"}[chunkId] + ".chunk.css";
};